import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CareerService } from '../careers/career.service';

@Component({
  selector: 'app-candidates',
  templateUrl: './candidates.component.html',
  styleUrls: ['./candidates.component.css']
})
export class CandidatesComponent implements OnInit {
  candidates = [];
  constructor(private _Activatedroute:ActivatedRoute,
    private _router:Router,private careerService: CareerService) {
    
   }
 paramId = {}
 job_id;
  ngOnInit() {
    this.paramId=this._Activatedroute.paramMap.subscribe(params => { 
       this.job_id = params.get('job_id'); 
       this.careerService.getCandidate(this.job_id).subscribe(res => {
        this.candidates = res.data
       })
   });
  }

}



// WEBPACK FOOTER //
// ./src/app/candidates/candidates.component.ts